'use client';

import Image from 'next/image';
import clsx from 'clsx';
import styles from './index.module.css';

interface ContentCardProps {
  image?: string;
  className?: string;
  onClick?: () => void;
}

export default function ContentCard({
  image,
  onClick,
  className = ''
}: ContentCardProps) {
  return (
    <div
      className={`relative rounded-lg overflow-hidden cursor-pointer group transition-all duration-300 ease-out hover:shadow-2xl transform-gpu will-change-transform ${className}`}
      onClick={onClick}
    >
      {image ? (
        <Image
          src={image || ''}
          className={clsx(styles.bgBanner, 'object-contain')}
          alt={'card'}
          fill
        />
      ) : (
        <div className={clsx(styles.bgBanner, 'w-full h-full')} />
      )}
    </div>
  );
}
